<div style="display:block;padding-top:10px;">
<app-data-table [columns]="tableColumns" [value]="appraisalHistories" [sortField]="'appraisalYear'"
                [disableSearch]="true" [bodyTemplate]="appraisalHistoryBody" [rightCaptionTemplate]="rightCaption">
  <ng-template #rightCaption>
    <div *ngIf="editable" class="p-col-12" style="text-align:right;">
      <button pButton type="button" class="action-secondary"
              icon="fa fa-plus" label="Appraisal History"
              pTooltip="Make New appraisal History" tooltipPosition="top"
              (click)="onClickAddRow()">
      </button>
    </div>
  </ng-template>

  <ng-template #appraisalHistoryBody let-columns="columns" let-row="row">
    <tr>
      <td *ngFor="let col of columns" [ngSwitch]="col.field">
        <span class="p-column-title">{{col.header}}</span>
        <span class="p-cell">
          <div *ngSwitchCase="'employeeRatingName'">
            {{row.employeeRatingName}} ({{row.employeeRatingScore}})
          </div>
          <div *ngSwitchCase="'managerRatingName'">
            {{row.employeeRatingName}} ({{row.managerRatingScore}})
          </div>
          <div *ngSwitchCase="'action'">
            <button *ngIf="editable"
                    pButton type="button" class="icon-action" icon="fa fa-pencil"
                    pTooltip="Update" tooltipPosition="top"
                    (click)="onClickEditRow(row)">
            </button>
            <button *ngIf="editable"
                    pButton type="button" class="icon-negative" icon="fa fa-trash"
                    pTooltip="Delete" tooltipPosition="top"
                    (click)="onClickDeleteRow(row)">
            </button>
          </div>
          <div *ngSwitchDefault>{{row[col.field]}}</div>
        </span>
      </td>
    </tr>
  </ng-template>

</app-data-table>
</div>

<p-confirmDialog></p-confirmDialog>
